module.exports = __webpack_public_path__ + "static/media/vu.e8e912e3.png";